import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';

export default class AccountBillingDetailsService {
    static getPolicyBillingSummary(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'), 'getPolicyBillingSummary', [policyNumber], additionalHeaders);
    }

    static getPaymentSummaryForPolicy_EY(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'), 'getPaymentSummaryForPolicy_EY', [policyNumber], additionalHeaders);
    }

    static getInvoiceDocument(invoiceNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'), 'getInvoiceDoc', [invoiceNumber], additionalHeaders);
    }

    static getAccountBillingSummary(accountNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'),
            'getAccountBillingDetails', [], additionalHeaders);
    }

    static getMonerisRequestURL(modeOfSource, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'), 'getMonerisRequestURL_EY', [modeOfSource], additionalHeaders);
    }
}
